import type { ThemeConfig } from "antd";

/**
 * Ant Design theme tokens.
 * These align with our CSS custom properties in designTokens.ts
 * but Ant Design needs JS values at ConfigProvider level.
 */
export const themeConfig: ThemeConfig = {
  token: {
    colorText: "#0F172A",
    colorTextSecondary: "#64748B",
    fontWeightStrong: 600,
    borderRadius: 12,
    colorPrimary: "#D81B60",
    colorPrimaryHover: "#B0124A",
    colorBgLayout: "#FAFAFA",
    colorBorder: "#E2E8F0",
    fontFamily: "'Inter', system-ui, -apple-system, sans-serif",
    fontSize: 15,
    lineHeight: 1.5,
    controlHeight: 42,
    controlHeightLG: 48,
  },
  components: {
    Button: {
      borderRadius: 12,
      borderRadiusLG: 14,
      controlHeight: 40,
      controlHeightLG: 48,
      fontWeight: 600,
    },
    Input: {
      borderRadius: 12,
      controlHeightLG: 48,
    },
    Card: {
      borderRadiusLG: 16,
    },
    Select: {
      borderRadius: 12,
      multipleItemBg: "#FDF0F4",
      multipleItemBorderColor: "#F6B3C7",
      multipleItemHeight: 28,
      multipleItemHeightLG: 28,
      optionSelectedBg: "#FDF0F4",
      optionSelectedColor: "#D81B60",
      optionSelectedFontWeight: 600,
    },
  },
};
